var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: () => _vm.hide(),
      expression: "() => hide()"
    }],
    staticClass: "base-dropdown"
  }, [_c('div', {
    ref: "button",
    staticClass: "base-dropdown__button tw-inline-block"
  }, [_vm._t("default", null, {
    "show": _vm.show,
    "hide": _vm.hide,
    "toggle": _vm.toggle
  })], 2), _c('div', {
    ref: "popper",
    staticClass: "base-dropdown__popper tw-absolute tw-w-56 tw-rounded-md tw-border tw-border-gray-100 tw-bg-white tw-shadow-lg"
  }, [_c('ul', {
    staticClass: "tw-p-2 tw-m-0"
  }, _vm._l(_vm.items, function (item, itemKey) {
    return _c('li', {
      key: itemKey,
      staticClass: "tw-m-0 tw-block tw-rounded-lg tw-px-4 tw-py-2 tw-text-sm tw-text-gray-500 hover:tw-bg-gray-50 hover:tw-text-gray-700 tw-cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return item.action();
        }
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };